import React from "react"
import DoughnutChartAtom from "views/atoms/charts/doughnuts/DoughnutChartAtom"
import NodeOrganization from "services/organizations/NodeOrganization"

const NodeDoughnutChartAtom = ({
  nodes = {
    doughnut_charts: [],
    doughnut_charts_data_total: { number: 0, unit: "" },
  },
  unitType = "count",
  title = "",
}) => {
  if (nodes.doughnut_charts.length === 0) return null

  const data = {
    doughnut_charts: nodes.doughnut_charts.map(({ data, label, type }) => ({
      data,
      label: NodeOrganization.getName(label, type, { countryShortName: true }),
    })),
    doughnut_charts_data_total: nodes.doughnut_charts_data_total,
  }

  return (
    <DoughnutChartAtom title={title} data={data} unitType={unitType} large />
  )
}

export default NodeDoughnutChartAtom
